module.exports = __webpack_public_path__ + "media/images/b2b_admin/routing_request_shortcut_icon-e26252a261c161c81dd02bd36972f443.svg";